// extracted by mini-css-extract-plugin
export default {"detailsStepContainer":"Ik7O34","footerContainer":"XWbmO4","selectedAssetsPanelContainer":"jhNwsA","connectionsPanelsContainer":"x_FI_L"};